import { render, staticRenderFns } from "./PaymentFormDesktop.vue?vue&type=template&id=6c5c2b48"
import script from "./PaymentFormDesktop.vue?vue&type=script&lang=js"
export * from "./PaymentFormDesktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports